const dev = {
    IS_DEV: true,
    TITLE: "DEV: School Accounts P6PP",
};

export default dev;

